var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketHistoryUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3589_5188)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 32,
    r: 20,
    fill: "#E6FFEC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3589_5188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4752 41C34.1359 41 31.7965 41 29.4572 41C29.0117 41 29.0275 40.9982 29.0093 40.5492C28.9521 39.14 29.1515 37.7835 29.8273 36.5204C30.6813 34.9244 31.9503 33.7732 33.6405 33.0716C33.8204 32.9967 33.9766 32.9949 34.1614 33.0716C35.7119 33.7199 37.2702 33.7241 38.8237 33.0823C39.0291 32.9973 39.2017 32.9931 39.4011 33.0823C41.9975 34.2347 43.5218 36.1857 43.9454 38.9664C44.0257 39.4932 43.9904 40.0212 43.9989 40.5492C44.0056 40.9988 44.0001 41 43.5546 41C41.1952 41 38.8352 41 36.4758 41H36.4752Z",
    fill: "#00FF3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4934 32.5585C33.8106 32.5561 31.6336 30.4142 31.6372 27.7808C31.6409 25.124 33.8137 22.9964 36.5189 23C39.2193 23.0036 41.383 25.1455 41.3744 27.8059C41.3659 30.4375 39.1846 32.5609 36.4928 32.5585H36.4934Z",
    fill: "#00FF3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3589_5188",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3589_5188"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3589_5188",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3589_5188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 18,
    fill: "white",
    transform: "translate(29 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketHistoryUserIcon);
export default __webpack_public_path__ + "static/media/ticket-history-user-icon.80904570730e9dc01415466834aa8848.svg";
export { ForwardRef as ReactComponent };